import { render, staticRenderFns } from "./steptwo.vue?vue&type=template&id=992cc01c&scoped=true&"
import script from "./steptwo.vue?vue&type=script&lang=js&"
export * from "./steptwo.vue?vue&type=script&lang=js&"
import style0 from "./steptwo.vue?vue&type=style&index=0&id=992cc01c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "992cc01c",
  null
  
)

export default component.exports